import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { GetPromotionInfo, Steps } from './hooks/useGetPromotionConfig'
import { useGetPromotionActions } from './hooks/useGetPromotionActions'

import * as Styles from './styles'

type ActionButtonsProps = {
  steps: Steps
  text: GetPromotionInfo
}

export const ActionButtons = ({ steps, text }: ActionButtonsProps) => {
  const { isPhone } = useMediaQueries()
  const { handleGetPromotionPage, handleOpenBookCoach } = useGetPromotionActions()

  const showScore = (completed?: boolean, score?: number) => {
    if (isPhone) return null
    if (completed) {
      return (
        <Styles.IconContainer>
          <Styles.Icon />
        </Styles.IconContainer>
      )
    }
    return <Styles.ScoreText>+{score}%</Styles.ScoreText>
  }

  return (
    <Styles.ProgressActionButtonsContainer>
      <Styles.ButtonContainer onClick={handleGetPromotionPage}>
        <Styles.ActionText>
          {isPhone ? text.promotion_button_mobile : text.promotion_button}
        </Styles.ActionText>
        {showScore(steps.get_promotion?.completed, steps.get_promotion?.score)}
      </Styles.ButtonContainer>
      <Styles.ButtonContainer onClick={handleOpenBookCoach}>
        <Styles.ActionText>{text.coach_button}</Styles.ActionText>
        {showScore(
          !steps.get_promotion?.completed || steps.career_coaching?.completed,
          steps.career_coaching?.score,
        )}
      </Styles.ButtonContainer>
    </Styles.ProgressActionButtonsContainer>
  )
}
